import React from "react";
import { useTranslation } from "react-i18next";
import { WIDGET_VERSION } from "@/config/security";
import logo from "../../public/Images/logo.png";

export const AboutPanel = ({ version = WIDGET_VERSION }) => {
  const { t } = useTranslation();

  return (
    <div className="gpc-conversations-container">
      <div className="gpc-conversations-header">
        <h3 className="gpc-conversations-title">{t("about.title")}</h3>
      </div>

      <div className="gpc-about-panel-content">
        <div className="gpc-about-panel-logo">
          <img
            src={logo}
            alt="TIA GPC Logo"
            className="gpc-about-panel-icon"
            style={{ width: "80px", height: "auto" }}
          />
        </div>

        <div className="gpc-about-panel-items">
          <div className="gpc-about-panel-item">
            <span className="gpc-about-panel-label">{t("about.product")}:</span>
            <span className="gpc-about-panel-value">TIA GPC</span>
            <a
              href="https://www.softiabot.com"
              target="_blank"
              rel="noopener noreferrer"
              className="gpc-about-panel-link"
            >
              www.softiabot.com
            </a>
          </div>

          <div className="gpc-about-panel-item">
            <span className="gpc-about-panel-label">{t("about.version")}:</span>
            <span className="gpc-about-panel-value">{version}</span>
          </div>

          <div className="gpc-about-panel-item">
            <span className="gpc-about-panel-label">{t("about.creator")}:</span>
            <span className="gpc-about-panel-value">
              SOFTIA Technologies Inc.
            </span>
            <a
              href="https://www.softia.ca"
              target="_blank"
              rel="noopener noreferrer"
              className="gpc-about-panel-link"
            >
              Softia.ca
            </a>
          </div>

          <div className="gpc-about-panel-footer">
            <p className="gpc-about-panel-rights">{t("about.rights")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
